import { Stack, Typography } from '@mui/joy';
import { CaretDown, CaretRight } from '@phosphor-icons/react';
import { useState } from 'react';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { DecoratorPosition, Level } from 'theme/enums';

interface IProps {
  title: string;
  children: JSX.Element;
  defaultExpanded?: boolean;
  iconPosition?: DecoratorPosition;
}

export const ExpandableSection = ({
  title,
  children,
  defaultExpanded = false,
  iconPosition = DecoratorPosition.END,
}: IProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const arrowIcon = isExpanded ? (
    <CaretDown size={24} weight="bold" />
  ) : (
    <CaretRight size={24} weight="bold" />
  );

  return (
    <>
      <Stack
        onClick={() => setIsExpanded(!isExpanded)}
        sx={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          cursor: 'pointer',
          marginBottom: isExpanded ? 1 : 0,
        }}
      >
        <Typography
          level={Level.TITLE_MD}
          {...(iconPosition === DecoratorPosition.START
            ? { startDecorator: arrowIcon }
            : { endDecorator: arrowIcon })}
          sx={{
            justifyContent: iconPosition === DecoratorPosition.END ? 'space-between' : undefined,
            width: '100%',
            alignItems: 'flex-start',
          }}
        >
          {title || DEFAULT_PLACEHOLDER}
        </Typography>
      </Stack>

      {isExpanded && children}
    </>
  );
};
